/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompletePasswordAuthRecoveryRequest } from '../models/CompletePasswordAuthRecoveryRequest';
import type { InitPasswordAuthRecoveryRequest } from '../models/InitPasswordAuthRecoveryRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PasswordAuthRecoveryService {
    /**
     * Init Password Auth Recovery Endpoint
     * Инициализация восстановления пароля по email
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static initPasswordAuthRecoveryEndpointApiAuthPasswordAuthRecoveryPost(
        requestBody: InitPasswordAuthRecoveryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password-auth/recovery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Code: user_not_found`,
                422: `Code: validation_error`,
                429: `Code: password_auth_recovery_rate_limited`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Complete Password Auth Recovery Endpoint
     * Завершение восстановления пароля
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static completePasswordAuthRecoveryEndpointApiAuthPasswordAuthRecoveryCompletePost(
        requestBody: CompletePasswordAuthRecoveryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password-auth/recovery/complete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Possible errors: password_auth_recovery_token_not_found, no_password_auth`,
                404: `Code: user_not_found`,
                422: `Code: validation_error`,
                429: `Code: password_auth_recovery_rate_limited`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
